'use strict';

import './LHWidget';
import Util from './Util';
import { fetch } from 'whatwg-fetch'
import config from './Config';
import create_functions from './CreateWidgetElements'
import SWorker from 'simple-web-worker'

function Widget (id, name, type, widgetOptions, validator) {
    Util.console.log('Widget.js: Begin to create widget', id, name, type, widgetOptions, validator);

    var showMethod = null;

    var objectElementWidgets = [
      'Smartoffer_Desktop',
      'Generic',
      'Social_Proof',
      'Subscribe',
      'Coupon',
      'Рекомендации',
      'wish_list_noframe',
      'Smartoffer_Mobile_v2',
      'Notification',
      'Recommendations_Svyaznoy',
      'Average_Check_Enlarger',
      'Average_Check_Enlarger_v2',
      'Wheel_Of_Fortune',
      'Scratch',
      'Last_Viewed',
      'News_Subscription',
      'News_Subscription_3_steps',
      'News_Subscription_2_steps',
      'Abandoned_Cart',
      'Wheel_Of_Fortune_mobile',
    ]
    var objectWidgets = [
      'XConsole',
      'New_Smart_final'
    ]
    var iframeWidgets = [
      'Smart_final',
      'Smart_offer_mobile_iframe',
      'wish_list'
    ]
    function preCompileVariables(variablesObject) {
      var variables = {}
      try {
        if ( typeof variablesObject !== 'undefined' )
        {
          variablesObject.forEach(function(variable) {
            variables[variable.name] = variable.value;
          })

          return variables
        }
      } catch (error) {
        console.error(error)
      }
      return false
    }
    function mergeWidgetOptionsAndCallRenderFunc (htmlVariables, cssVariables, jsVariables, jsonSettings) {
      let htmlDefaultVariables = preCompileVariables(jsonSettings.html_vars)
      let cssDefaultVariables = preCompileVariables(jsonSettings.css_vars)
      let jsDefaultVariables = preCompileVariables(jsonSettings.js_vars)

      htmlVariables = {...htmlDefaultVariables, ...htmlVariables}
      cssVariables = {...cssDefaultVariables, ...cssVariables}
      jsVariables = {...jsDefaultVariables, ...jsVariables}

      if (objectElementWidgets.indexOf(type) !== -1) {
        create_functions.ObjectElementWidget(id, type, htmlVariables, cssVariables, jsVariables);
      }
      else {
        if (iframeWidgets.indexOf(type) !== -1) {
          create_functions.IframeWidget(id, type, htmlVariables, cssVariables, jsVariables);
        }
        else {
          if (objectWidgets.indexOf(type) !== -1) {
            create_functions.ObjectWidget(id, type, htmlVariables, cssVariables, jsVariables);
          } 
          else {
            create_functions.EmbeddedWidget(id, type, htmlVariables, cssVariables, jsVariables);
          }
        }
      }
    }

    SWorker.run((widgetOptions, id, config, strPreCompileVariables) => {
      var preCompileVariables = eval('('+strPreCompileVariables+')')
      var htmlVariables = preCompileVariables(widgetOptions.html_vars);
      var cssVariables = preCompileVariables(widgetOptions.css_vars);
      var jsDefaultVariables = [
          {
              name: 'widgetId',
              value: id
          }
      ];
      var jsVariables = preCompileVariables(jsDefaultVariables.concat(widgetOptions.js_vars || []));

      let baseUrlJson = 'https://media.leadhit.io/widgets_v2'
      if(config.widgets_path.length > 0) {
        baseUrlJson = config.widgets_path
      }
      return { baseUrlJson, htmlVariables, cssVariables, jsVariables }
    }, [widgetOptions, id, config, preCompileVariables.toString()])
        .then(function(result) {

            var htmlVariables = result.htmlVariables
            var cssVariables = result.cssVariables
            var jsVariables = result.jsVariables

            let url = `${result.baseUrlJson}/${type}/widget.json`
            if(window.Leadhit.store.state.siteSettings.hasOwnProperty('next_vers_features') && 
              window.Leadhit.store.state.siteSettings.next_vers_features.hasOwnProperty('widgets') && 
              window.Leadhit.store.state.siteSettings.next_vers_features.widgets === true) {
                if(ENV === 'production') {
                  url = 'https://track-api.leadhit.io/get/widgets/default_options'
                }
                else if(ENV === 'development') {
                  url = 'http://127.0.0.1:8008/get/widgets/default_options'
                }

                fetch(url)
                  .then(resp => resp.text())
                  .then((response) => {
                    let response_result = JSON.parse(response)
                    let background_result = Util.getTrackerBackendBackgroundResult.call(Util, response_result.result_id, response_result.result_type, 900000)
                    background_result
                    .then((response) => {
                      if(response === 'error') {
                        Util.console.log('Timed out of getTrackerBackendBackgroundResult function')
                      }
                      else {
                        let jsonSettings = {
                          html_vars: response.result.html[type],
                          css_vars: response.result.css[type],
                          js_vars: response.result.js[type],
                        }

                        mergeWidgetOptionsAndCallRenderFunc(htmlVariables, cssVariables, jsVariables, jsonSettings)
                      }
                    })
                  })
            }
            else {
              fetch(url)
                .then(resp => resp.text())
                .then( (jsonSettingsResponse) => {
                  Util.console.log(`Load json ${id}`)
                  try {
                    var jsonSettings = JSON.parse(jsonSettingsResponse)
                  } catch(error) {
                    Util.console.log(error)
                    return
                  }

                  mergeWidgetOptionsAndCallRenderFunc(htmlVariables, cssVariables, jsVariables, jsonSettings)
                })
            }
        })

    return {
        getWidgetId: function() {
            return id;
        },
        addShowInterface: function(widgetObject) {
            var interfaceAdded = false
            if (typeof widgetObject.run === 'function' && !showMethod) {
                showMethod = widgetObject.run.bind(widgetObject);
                interfaceAdded = true;
            } else if ( typeof widgetObject.show === 'function' && !showMethod ) {
                showMethod = widgetObject.show.bind(widgetObject);
                interfaceAdded = true;
            }
            if ( interfaceAdded == true )
            {
                setTimeout(function () {
                    Util.setTriggers(widgetOptions, validator, id, showMethod);
                }, 0);
            }
        }
    };
}

export default Widget;